import { HeaderChangeAction } from './../../../core/store/general/actions';
import { environment } from './../../../../environments/environment';
import { SharedContainer } from './../../shared.container';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './privacy.component.html',
})
export class PrivacyComponent implements OnInit {


  constructor(protected sharedContainer: SharedContainer) { }


  ngOnInit() {
    this.sharedContainer.generalState$.dispatch(new HeaderChangeAction(1, {headerType: 'home'}));
   }

}
